export default {
  wrapper: {
    position: 'relative',
    bg: 'white',
    color: 'gray600',
    pt: '60px',
  },
  footer: {
    flexDirection: ['column', null, 'row'],
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: ['center', 'flex-start'],
    '& > div:first-of-type': {
      width: [null, '100%', null, null, 'auto'],
    },
    rowGap: '30px',
  },
  footerLogo: {
    mb: '16px',
  },
  buttonColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  topButtons: {
    flexDirection: 'column',
    gap: '16px',
  },
  buttonsWrapper: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    '& > a, a:last-of-type': {
      m: 0,
      '& > div:hover': {
        textDecoration: 'underline',
      },
    },
  },
  bottomFooterWrapper: {
    pb: '40px',
  },
  bottomFooter: {
    flexDirection: ['column', null, 'row'],
    justifyContent: ['start', null, null, 'end'],
    alignItems: ['start', null, null, 'center'],
    flexWrap: 'wrap',
    gap: '40px',
    '& > div:first-of-type': {
      width: [null, 'auto', null, '100%', 'auto'],
      mr: 'auto',
      ml: 0,
    },
    '& > div:last-of-type': {
      mr: [null, null, 0, 0, 0],
      ml: [null, 0, null, null, 'auto'],
      flex: ['auto', 'auto', 'auto', 1, 'auto'],
    },
  },
  buttonRow: {
    gap: '24px',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: [
      'flex-end',
      'flex-start',
      'flex-start',
      'space-between',
      'flex-end',
    ],
  },
  bottomButtons: {
    flexDirection: 'row',
    justifyContent: 'start',
    gap: '24px',
    '& svg:last-of-type': {
      width: 'auto',
      height: 'auto',
    },
  },
  dateSign: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  marketButtons: {
    gap: '16px',
  },
};
